var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pop-up",
    transform: "translate(-2927.000000, -86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(2927.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#000000",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0764741,14.6190476 C17.1811025,14.6190476 17.2831624,14.6497386 17.3686211,14.7069039 L22.7857576,18.3306955 C23.0141695,18.4835163 23.068526,18.7827156 22.9071737,18.9990206 C22.8760926,19.0406878 22.8381896,19.0773912 22.7948941,19.1077464 L17.3777796,22.9058329 C17.1530003,23.063428 16.8359096,23.0186242 16.6695157,22.8057801 C16.6049596,22.7232086 16.570115,22.623185 16.5701153,22.5204452 L16.5701153,20.0771056 L12.1414572,20.0771056 C8.98530077,20.0940972 7.27147436,18.6169895 7,15.6458032 C7.27424833,15.9177324 8.47288767,17.5221839 12.1414572,17.5221839 C14.5871702,17.5221839 16.0634042,17.4955601 16.5701153,17.4423751 L16.5701153,15.0985671 C16.5701153,14.8337264 16.7968099,14.6190476 17.0764741,14.6190476 Z M13.3304843,7.19422037 C13.3950404,7.27677128 13.429885,7.37679511 13.4298847,7.47953519 L13.4298847,9.92288086 L17.8585428,9.92288086 C21.0146992,9.90588914 22.7285256,11.3830006 23,14.3541943 C22.7257517,14.0822644 21.5271123,12.4778089 17.8585428,12.4778089 C15.4128298,12.4778089 13.9365958,12.5044327 13.4298847,12.5576178 L13.4298847,14.9014317 C13.4298847,15.166273 13.2031901,15.3809524 12.9235259,15.3809524 C12.8188975,15.3809524 12.7168376,15.3502613 12.6313789,15.2930958 L7.21424236,11.6692953 C6.98583051,11.5164741 6.93147399,11.217274 7.09282633,11.0009685 C7.12390736,10.9593012 7.16181043,10.9225977 7.20510589,10.8922424 L12.6222204,7.09416733 C12.8469997,6.93657181 13.1640904,6.98137572 13.3304843,7.19422037 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmSwap);
export default __webpack_public_path__ + "static/media/confirm-swap.798143e47beba58d3e7f12aaf875d17d.svg";
export { ForwardRef as ReactComponent };